import type { Dispatch } from 'react';

import { User } from '../../services/types';
import { getUser, storeUser } from '../../utilities';
import { ActionPayload, ActionType, State } from './type';

export const setSessionUser =
  (user: User | null) => (state: State, dispatch?: Dispatch<ActionPayload>) => {
    if (user) storeUser(user);
    dispatch?.({ type: ActionType.SET_USER, payload: { user } });
  };

export const refreshSessionUser = () => (state: State, dispatch?: Dispatch<ActionPayload>) => {
  dispatch?.({ type: ActionType.SET_USER, payload: { user: getUser() } });
};
